$(() => {
    const $form = $(`#add-to-cart-form`);

    if (!$form.length) return;

    const formAccessor = (form) => (name) => form.find(`input[name="${name}"]`).val();
    const formValue = formAccessor($form);
    const type = $form.data('product-type');
    const variationCode = formValue('code');
    const participantId = (fn, ln, email) => window.btoa(`${fn}${ln}${email}`);
    const getCurrentParticipants = () =>
        $('.added-participant')
            .map((_, li) => {
                return {
                    id: li.dataset.id,
                    firstname: li.dataset.fn,
                    lastname: li.dataset.ln,
                    email: li.dataset.email
                };
            })
            .get();

    $('#cart-updated-toast').toast({ delay: 2622 });

    $form.on(`submit`, (event) => {
        //console.log('submit', event);

        event.stopPropagation();
        event.preventDefault();

        if (window.productFields && window.dataLayer) {
            const productField = window.productFields.find(
                (x) => x.id === variationCode.toUpperCase()
            );

            if (productField) {
                window.dataLayer.push({ ecommerce: null });
                window.dataLayer.push({
                    event: 'addToCart',
                    ecommerce: {
                        currencyCode: `${productField.currencyCode}`,
                        add: {
                            products: [
                                {
                                    name: `${productField.name}`,
                                    id: `${productField.id}`,
                                    price: productField.price,
                                    category: `${productField.category}`,
                                    variant: `${productField.variant}`,
                                    quantity: formValue('quantity')
                                        ? formValue('quantity')
                                        : productField.quantity
                                }
                            ]
                        }
                    }
                });
            }
        }

        if (event.currentTarget.checkValidity()) {
            const updateModel = getUpdateModel(type);

            if (type === 'book') {
                const bookAddMessage = addBookMessage(formValue('quantity'));
                postToCart(updateModel, bookAddMessage);
            } else if (type === 'SingeAtendeeEduction') {
                postToCart(updateModel, addSingleParticipantMessage());
            } else {
                const newParticipant = readParticipantFromForm();
                postToCart(updateModel, addParticipantMessage(newParticipant));
            }
        } else {
            $form.addClass('was-validated').find(':invalid').first().focus();
        }
    });

    $('body').on('click', 'button[name="remove-participant"]', (event) => {
        event.stopPropagation();
        event.preventDefault();
        const participantId = $(event.currentTarget).val();
        const removedParticipant = readParticipantFromDOM(participantId);
        const updateModel = getRemoveParticipantModel(participantId);
        postToCart(updateModel, removedParticipantMessage(removedParticipant));
    });

    const postToCart = (updateModel, successMessage) => {
        $.post({
            url: `/api/commerce/cart`,
            data: updateModel,
            dataType: `json`,
            contentType: `application/json`
        }).done((data) => {
            if (data.success) {
                toastMessage(successMessage);
            } else {
                toastMessage(`Ett fel inträffade: \n${data.errorMsg}`, false);
                return;
            }

            resetForm();

            updateCartIcon(data.payload.totalCount);
            if (type == 'book' || type == 'SingeAtendeeEduction') return;
            const participants = data.payload.items[variationCode]
                ? data.payload.items[variationCode].members || []
                : [];

            //console.log(participants);

            if (participants.length) {
                $('#added-participants').removeClass('d-none');
                const last = participants[participants.length - 1];
            } else {
                $('#added-participants').addClass('d-none');
            }

            updateAddedParticipants(
                document.getElementById('added-participant-list'),
                document.getElementById('participant-template'),
                participants
            );
        });
    };

    const getRemoveParticipantModel = (participantId) => {
        const filteredModel = getCurrentParticipants().filter(
            (participant) => participant.id !== participantId
        );

        return JSON.stringify({
            isCheckout: false,
            items: {
                [variationCode]: {
                    members: filteredModel.length ? filteredModel : null
                }
            }
        });
    };

    const resetForm = () => {
        $('#given-name, #family-name, #email-address').val('');
        $form.removeClass('was-validated');
        $('#given-name').focus();
    };

    const toastMessage = (htmlMessage, success = true) => {
        $('#toast-message').html(htmlMessage);

        const cartUpdatedToast = $('#cart-updated-toast');

        cartUpdatedToast.find('.toast-header')?.toggleClass('bg-primary', success);
        cartUpdatedToast.find('.toast-header')?.toggleClass('bg-danger', !success);

        let toastTitleEl = cartUpdatedToast.find('.toast-header > strong');

        if (toastTitleEl) {
            toastTitleEl.text(
                success ? toastTitleEl.data('success-msg') : toastTitleEl.data('error-msg')
            );
        }

        cartUpdatedToast.toast('show');
    };

    const addParticipantMessage = (participant) =>
        `<strong>${participant.firstname} ${participant.lastname}</strong> tillagd som deltagare.`;

    const removedParticipantMessage = (participant) =>
        `<strong>${participant.firstname} ${participant.lastname}</strong> borttagen som deltagare.`;

    const addBookMessage = (quantity) =>
        `<strong>${quantity}</strong> exemplar ${
            parseInt(quantity) > 1 ? 'tillagda' : 'tillagt'
        } i varukorgen.`;

    const addSingleParticipantMessage = () => `Varan är tillagd i varukorgen.`;

    const updateCartIcon = (totalCount) => {
        $('.shopping-cart-top-link .shopping-cart-icon__count').text(totalCount);
        if (totalCount == 0) {
            $('.shopping-cart-top-link .shopping-cart-icon').addClass('shopping-cart-icon--empty');
        } else {
            $('.shopping-cart-top-link .shopping-cart-icon').removeClass(
                'shopping-cart-icon--empty'
            );
        }
    };

    const getUpdateModel = (type) => {
        const model = {
            isCheckout: false,
            items: {
                [variationCode]: {}
            }
        };

        switch (type) {
            case 'book':
                model.items[variationCode]['quantity'] = parseInt(formValue('quantity'));
                break;
            case 'SingeAtendeeEduction':
                model.items[variationCode]['quantity'] = 1;
                model.items[variationCode]['role'] = false;
                break;
            default:
                model.items[variationCode]['members'] = [
                    ...getCurrentParticipants(),
                    readParticipantFromForm()
                ];
                break;
        }

        return JSON.stringify(model);
    };

    const readParticipantFromForm = () => {
        const participant = {
            firstname: formValue('given-name'),
            lastname: formValue('family-name'),
            email: formValue('email-address')
        };

        participant.id = participantId(
            participant.firstname,
            participant.lastname,
            participant.email
        );

        return participant;
    };

    const readParticipantFromDOM = (participantId) => {
        const $participant = $('.added-participant')
            .filter((_, element) => $(element).data('id') === participantId)
            .first();

        return {
            firstname: $participant.data('fn'),
            lastname: $participant.data('ln'),
            email: $participant.data('email'),
            id: $participant.data('id')
        };
    };

    const updateAddedParticipants = (ul, template, particpantData) => {
        const participantNodes = particpantData.map((participant) =>
            createParticipantNode(template, participant)
        );

        while (ul.firstChild) {
            ul.removeChild(ul.firstChild);
        }
        for (let i in participantNodes) {
            ul.appendChild(participantNodes[i]);
        }
    };

    const createParticipantNode = (template, participant) => {
        const fragment = template.content.cloneNode(true);
        const li = fragment.firstElementChild;

        li.setAttribute('data-fn', participant.firstName);
        fragment.querySelector('.fn').textContent = participant.firstName;

        li.setAttribute('data-ln', participant.lastName);
        fragment.querySelector('.ln').textContent = participant.lastName;

        li.setAttribute('data-email', participant.email);
        fragment.querySelector('.email').textContent = participant.email;

        li.setAttribute('data-id', participant.id);
        fragment.querySelector('button[name="remove-participant"]').value = participant.id;

        return li;
    };
});
